import SimpleAutocompleteFactory from "../../../../../components/Autocomplete/SimpleAutocompleteFactory"
import { TransactionFilterSynchronizationModeValueEnum } from "../../../../../services/api/openapi"

export const SynchronizationModeFilter = SimpleAutocompleteFactory<TransactionFilterSynchronizationModeValueEnum>({
  automatic: "Automatically synchronized",
  manual: "Manually marked as synchronized",
})

export default SynchronizationModeFilter
